import { render, staticRenderFns } from "./OrganizationsByTypeTableWidget.vue?vue&type=template&id=23b91d30&scoped=true"
import script from "./OrganizationsByTypeTableWidget.vue?vue&type=script&lang=js"
export * from "./OrganizationsByTypeTableWidget.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsByTypeTableWidget.vue?vue&type=style&index=0&id=23b91d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b91d30",
  null
  
)

export default component.exports